import { ColorName, COLORS } from '@connect-x-app/shared-ui';

export const LightTheme: AppTheme = {
  colors: {
    accent: COLORS.romeo.$05,
    attention: COLORS.andes.$06,
    attentionSecondary: COLORS.andes.$03,
    attentionSubtle: COLORS.romeo.$03,
    attentionSubtleBorder: COLORS.romeo.$04,
    attentionTertiary: COLORS.andes.$08,
    backdrop: COLORS.bogota.$12,
    background: COLORS.victor.$07,
    backgroundSecondary: COLORS.uniform.$03,
    border: COLORS.zulu.$03,
    card: COLORS.yuma.$01,
    caution: COLORS.fuji.$08,
    cautionSecondary: COLORS.fuji.$05,
    coreLight: COLORS.victor.$09,
    disabled: COLORS.zulu.$03,
    error: COLORS.etna.$06,
    imported: COLORS.rocky.$05,
    inputBackground: COLORS.victor.$04,
    notification: COLORS.etna.$06,
    onAccent: COLORS.zulu.$11,
    onAttention: COLORS.zulu.$08,
    onBackground: COLORS.zulu.$08,
    onSecondary: COLORS.yuma.$01,
    onSuccess: COLORS.yuma.$01,
    pillBackground: COLORS.zulu.$08,
    pillBorder: COLORS.zulu.$08,
    pillText: COLORS.yuma.$01,
    placeholder: COLORS.zulu.$03,
    primary: COLORS.romeo.$06,
    secondary: COLORS.zulu.$08,
    selected: COLORS.romeo.$03,
    shadow: COLORS.bogota.$12,
    success: COLORS.everest.$08,
    successSecondary: COLORS.everest.$03,
    surface: COLORS.yuma.$01,
    surfaceAccentTertiary: COLORS.romeo.$04,
    surfaceSelected: COLORS.romeo.$03,
    text: COLORS.zulu.$08,
    unclear: COLORS.montblanc.$06,
  },
  dark: false,
};

export const DarkTheme: AppTheme = {
  colors: {
    accent: COLORS.romeo.$05,
    attention: COLORS.andes.$06,
    attentionSecondary: COLORS.andes.$03,
    attentionSubtle: COLORS.romeo.$03,
    attentionSubtleBorder: COLORS.romeo.$04,
    attentionTertiary: COLORS.andes.$08,
    backdrop: COLORS.bogota.$12,
    background: COLORS.zulu.$11,
    backgroundSecondary: COLORS.zulu.$07,
    border: COLORS.zulu.$07,
    card: COLORS.zulu.$09,
    caution: COLORS.fuji.$05,
    cautionSecondary: COLORS.fuji.$05,
    coreLight: COLORS.zulu.$09,
    disabled: COLORS.zulu.$08,
    error: COLORS.etna.$05,
    imported: COLORS.rocky.$05,
    inputBackground: COLORS.zulu.$12,
    notification: COLORS.etna.$06,
    onAccent: COLORS.zulu.$11,
    onAttention: COLORS.zulu.$08,
    onBackground: COLORS.yuma.$01,
    onSecondary: COLORS.yuma.$01,
    onSuccess: COLORS.yuma.$01,
    pillBackground: COLORS.zulu.$11,
    pillBorder: COLORS.yuma.$01,
    pillText: COLORS.yuma.$01,
    placeholder: COLORS.zulu.$06,
    primary: COLORS.romeo.$06,
    secondary: COLORS.zulu.$07,
    selected: COLORS.romeo.$09,
    shadow: COLORS.bogota.$12,
    success: COLORS.everest.$04,
    successSecondary: COLORS.everest.$03,
    surface: COLORS.zulu.$09,
    surfaceAccentTertiary: COLORS.quebec.$01,
    // @ts-expect-error just following design...
    surfaceSelected: 'rgba(0, 0, 0, 0.20)',
    text: COLORS.yuma.$01,
    unclear: COLORS.montblanc.$06,
  },
  dark: true,
};

export type AppTheme = {
  colors: {
    accent: ColorName;
    attention: ColorName;
    attentionSecondary: ColorName;
    attentionSubtle: ColorName;
    attentionSubtleBorder: ColorName;
    attentionTertiary: ColorName;
    backdrop: ColorName;
    background: ColorName;
    backgroundSecondary: ColorName;
    border: ColorName;
    card: ColorName;
    caution: ColorName;
    cautionSecondary: ColorName;
    coreLight: ColorName;
    disabled: ColorName;
    error: ColorName;
    imported: ColorName;
    inputBackground: ColorName;
    notification: ColorName;
    onAccent: ColorName;
    onAttention: ColorName;
    onBackground: ColorName;
    onSecondary: ColorName;
    onSuccess: ColorName;
    pillBackground: ColorName;
    pillBorder: ColorName;
    pillText: ColorName;
    placeholder: ColorName;
    primary: ColorName;
    secondary: ColorName;
    selected: ColorName;
    shadow: ColorName;
    success: ColorName;
    successSecondary: ColorName;
    surface: ColorName;
    surfaceAccentTertiary: ColorName;
    surfaceSelected: ColorName;
    text: ColorName;
    unclear: ColorName;
  };
  dark: boolean;
};
